import * as React from 'react';
import { getTheme, ITheme, Separator, Stack, ISeparatorStyles, Text, FontIcon } from '@fluentui/react';

export enum NavigationStatType {
  default,
  // Warning card
  warning,
  // Error card
  error
}
const theme: ITheme = getTheme();

// TODO: why is this separatorStyle different from all the other ones?
const separatorStyles: ISeparatorStyles = {
  root: {
    display: 'flex',
    height: '85%',
    selectors: {
      '::after': {
        background: theme.palette.neutralQuaternary
      },
      '::before': {
        background: theme.palette.neutralQuaternary
      }
    }
  },
  content: {}
};

export interface NavigationStatProps {
  value: number;
  displayName: string;
  statsType: NavigationStatType;
  tooltipText?: string;
  enableLeftBorder: boolean;
}

export const NavigationStat: React.FunctionComponent<NavigationStatProps> = props => {
  let icon;
  switch (props.statsType) {
    case NavigationStatType.error:
      icon = (
        <FontIcon
          className="ms-IconExample mx-1"
          iconName="AlertSolid"
          style={{ color: theme.palette.red, fontSize: theme.fonts.medium.fontSize }}
        />
      );
      break;
    case NavigationStatType.warning:
      icon = (
        <FontIcon
          iconName="WarningSolid"
          className="ms-IconExample mx-1"
          style={{ color: theme.palette.yellow, fontSize: theme.fonts.medium.fontSize }}
        />
      );
      break;
    default:
      icon = null;
  }
  return (
    <Stack horizontal>
      {props.enableLeftBorder && (
        <Stack.Item grow>
          <Separator vertical styles={separatorStyles} />
        </Stack.Item>
      )}
      <Stack.Item className={props.enableLeftBorder ? 'px-1 ' : 'pr-1'}>
        <Stack>
          <Stack.Item>
            <Stack horizontal>
              <Stack.Item>
                <Text>{props.value}</Text>
              </Stack.Item>
              <Stack.Item styles={{ root: { height: '16px', width: '16px' } }}>{icon}</Stack.Item>
            </Stack>
          </Stack.Item>
          <Stack.Item>
            <Text variant={'medium'}>{props.displayName}</Text>
          </Stack.Item>
        </Stack>
      </Stack.Item>
    </Stack>
  );
};
